<div role="status">
  <app-toast
    [message]="toastProperties.toastMessage | translate"
    [showsToast]="toastProperties.showToast"
    [state]="toastProperties.toastType"
    toastPosition="right"
    toastVerticalPosition="top"
  ></app-toast>
</div>
<div class="content" [ngSwitch]="screen">
  <form
    autocomplete="off"
    (ngSubmit)="onSubmitMfa(mfaInput)"
    #mfaForm="ngForm"
    class="mfa-form"
    *ngSwitchCase="'mfa'"
  >
    <div class="title-container" [ngSwitch]="mfaType">
      <h1 *ngSwitchCase="'sms'" class="title">
        {{ "MFA.TITLE" | translate }}
      </h1>
      <h1 *ngSwitchCase="'email'" class="title">
        {{ "MFA.EMAIL.TITLE" | translate }}
      </h1>
      <h1 *ngSwitchCase="'totp'" class="title">
        {{ "MFA.TOTP.TITLE" | translate }}
      </h1>
      <div>
        <p *ngSwitchCase="'sms'" class="description">
          {{ "MFA.HINT" | translate }}
        </p>
        <p *ngSwitchCase="'email'" class="description">
          {{ "MFA.EMAIL.HINT" | translate }}
        </p>
        <p *ngSwitchCase="'totp'" class="description">
          {{ "MFA.TOTP.HINT" | translate }}
        </p>
        <div role="alert">
          <c-banner
            *ngIf="error"
            class="error-banner"
            [style]="'error'"
            [inline]="false"
            [message]="error.message | translate"
            [actionButtonText]="error.action | translate"
            [showCloseButton]="false"
            [iconPositionX]="'center'"
            (actionButtonClick)="goBackToLogin('cancelPressed')"
          ></c-banner>
        </div>
      </div>
    </div>
    <div class="flex-column gap-sm">
      <div class="input-container">
        <c-input-text
          name="verificationCode"
          type="text"
          [label]="'MFA.CODE' | translate"
          [(ngModel)]="mfaCode"
          [ngModelOptions]="{ updateOn: 'blur' }"
          #mfaInput="ngModel"
          maxLength="6"
          minLength="6"
          pattern="\d{6,6}"
          inputmode="numeric"
          class="full-width"
          required
          placeholder="{{ 'MFA.PLACEHOLDER' | translate }}"
        >
          <div error-container role="alert">
            <p *ngIf="mfaInput.touched && mfaInput.errors" class="input-error">
              {{ "REGISTER.VERIFY_EMAIL.ERRORS.LENGTH" | translate }}
            </p>
          </div>
        </c-input-text>
      </div>
      <mat-checkbox
        name="mfaTrustDevice"
        [(ngModel)]="mfaTrustDevice"
        class="mfa-checkbox"
      >
        {{ "MFA.REMEMBER_DEVICE" | translate }}
      </mat-checkbox>
    </div>
    <div class="flex-column gap-sm">
      <c-button
        [text]="'MFA.CONTINUE' | translate"
        buttonType="neutral"
        buttonStyle="fill"
        size="large"
        type="submit"
        class="full-button"
      ></c-button>
      <c-button
        class="full-button"
        (onClick)="goBackToLogin('cancelPressed')"
        [text]="'MFA.BACK_BUTTON' | translate"
        buttonType="neutral"
        buttonStyle="outline"
        size="large"
      >
      </c-button>
    </div>
    <p class="resend-text" *ngIf="mfaType === 'sms'">
      <span>{{ "MFA.EMAIL.RESEND.TEXT" | translate }} </span>
      <button (click)="requestNewCode()" class="resend-text resend-button">
        {{ "MFA.RESEND_SMS" | translate }}
      </button>
      <span> {{ "MFA.EMAIL.RESEND.OR" | translate }} </span>
      <a class="resend-link" href="mailto:support@cariloop.com">
        {{ "MFA.EMAIL.RESEND.LINK_2" | translate }}
      </a>
    </p>
    <p class="resend-text" *ngIf="mfaType === 'email'">
      <span>{{ "MFA.EMAIL.RESEND.TEXT" | translate }} </span>
      <button (click)="requestNewCode()" class="resend-text resend-button">
        {{ "MFA.EMAIL.RESEND.LINK_1" | translate }}
      </button>
      <span> {{ "MFA.EMAIL.RESEND.OR" | translate }} </span>
      <a class="resend-link" href="mailto:support@cariloop.com">
        {{ "MFA.EMAIL.RESEND.LINK_2" | translate }}
      </a>
    </p>
    <app-countdown
      (onEnd)="screen = 'mfaError'; mfaErrorLabel = 'MFA.TIMEOUT_ERROR'"
      [limit]="mfaLimit()"
    ></app-countdown>
  </form>
  <div class="mfa-error" role="alert">
    <p class="mfa-error-text" *ngSwitchCase="'mfaError'">
      {{ mfaErrorLabel | translate }}
    </p>
  </div>
  <c-button
    *ngSwitchCase="'mfaError'"
    [text]="'MFA.BACK' | translate"
    buttonType="neutral"
    buttonStyle="fill"
    size="large"
    class="full-button"
    (onClick)="screen = 'mfa'; goBackToLogin('cancelPressed')"
  ></c-button>
</div>
